// extracted by mini-css-extract-plugin
module.exports = {"planDescriptionItem":"PlanDescriptionItem_planDescriptionItem__3zP_Z"};